import { CommonContext } from "hooks/CommonContext";
import React, { useContext, useState } from "react";
import { IoCopyOutline, IoCheckmarkOutline } from "react-icons/io5";
import OpenCandidateResume from "components/OpenCandidateResume";
import { convertToLocalTime } from "utils/commonUtils";
import { injectDrawerStyles } from "./drawerStyles";

injectDrawerStyles();

const AboutSection = () => {
  const { interviewDetails } = useContext(CommonContext);
  const url = window.location.href;
  const baseUrl = window.location.origin;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url)
      .then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); })
      .catch((err) => console.error("Failed to copy:", err));
  };

  return (
    <>
      {/* ── Header ── */}
      <div className="dw-header">
        <span className="dw-title">About</span>
      </div>

      {/* ── Interview info ── */}
      <div className="dw-body">
        <div className="dw-row">
          <span className="dw-label">Job Role</span>
          <span className="dw-value">{interviewDetails.jobDetails.displayName}</span>
        </div>

        <div className="dw-row">
          <span className="dw-label">Interview link</span>
          <span className="dw-value" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <a href={url} style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {baseUrl}/...
            </a>
            <button
              className={`dw-copy-btn${copied ? " dw-copied" : ""}`}
              onClick={handleCopy}
              title={copied ? "Copied!" : "Copy URL"}
            >
              {copied ? <IoCheckmarkOutline /> : <IoCopyOutline />}
            </button>
          </span>
        </div>

        <div className="dw-row">
          <span className="dw-label">Date &amp; Time</span>
          <span className="dw-value">
            {convertToLocalTime(interviewDetails.startDate, "MMMM D, YYYY")},{" "}
            {convertToLocalTime(interviewDetails.startDate, "h:mm A")}
          </span>
        </div>

        <div className="dw-row">
          <span className="dw-label">Interviewers</span>
          <span className="dw-value">
            {interviewDetails.interviewerName.map((iv, i) => (
              <span key={"iv-" + iv.firstName + iv.lastName}>
                {iv.firstName} {iv.lastName}
                {interviewDetails.interviewerName.length > i + 1 && ", "}
              </span>
            ))}
          </span>
        </div>

        {/* ── Candidate Info sub-section ── */}
        <div className="dw-subheader">
          <span className="dw-subtitle">Candidate Info</span>
        </div>

        <div className="dw-row">
          <span className="dw-label">Name</span>
          <span className="dw-value">
            {interviewDetails.candidateDetails.firstName}{" "}
            {interviewDetails.candidateDetails?.lastName}
          </span>
        </div>

        <div className="dw-row">
          <span className="dw-label">Resume</span>
          <span className="dw-value"><OpenCandidateResume /></span>
        </div>

        {interviewDetails.candidateDetails?.linkedinLink && (
          <div className="dw-row">
            <span className="dw-label">LinkedIn</span>
            <span className="dw-value">
              <a
                href={`https://${interviewDetails.candidateDetails.linkedinLink}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {interviewDetails.candidateDetails.linkedinLink}
              </a>
            </span>
          </div>
        )}

        {interviewDetails.candidateDetails?.githubLink && (
          <div className="dw-row">
            <span className="dw-label">GitHub</span>
            <span className="dw-value">
              <a
                href={`https://${interviewDetails.candidateDetails.githubLink}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {interviewDetails.candidateDetails.githubLink}
              </a>
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default AboutSection;